export default __webpack_public_path__ + "static/media/todayOrders.f4f9a3a6.svg";